module.exports = __webpack_public_path__ + "static/media/progress5.2a765ce1.png";